var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{on:{"click":_vm.imprimir}},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s('Histórico Transferegov.br')}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }